(function () {
  const banner = document.querySelector('[data-announcement-banner]');
  if (!banner) return;

  const root = document.documentElement;

  function syncBannerHeight() {
    root.style.setProperty('--announcement-banner-height', `${banner.offsetHeight}px`);
    window.dispatchEvent(new CustomEvent('milk:announcement-resize'));
  }

  syncBannerHeight();

  if (typeof ResizeObserver !== 'undefined') {
    const observer = new ResizeObserver(syncBannerHeight);
    observer.observe(banner);
  } else {
    window.addEventListener('resize', syncBannerHeight);
  }
})();
